import { NotFoundError } from './NotFoundError';
import { UnauthenticatedError } from './UnauthenticatedError';
import { UnauthorizedError } from './UnauthorizedError';

export const errors = {
  NotFoundError,
  UnauthenticatedError,
  UnauthorizedError,
};
